import { Config } from "../../../configurations/config";

export const EmployeesMonthlyLeaves_API = {
	//-----------------------------------Employees Monthly Leaves Listing ------------------------//
	GetEmployeesMonthlyLeaves: `${Config.server_url}${Config.api_prefix}/Leave/EmployeesMonthlyLeaves`,
	GetAllActiveEmployeeList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/Leave/EmployeesMonthlyLeaves/ExportToExcel`,
	GetAdminEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees?AllEmployees=true `,
	GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
};
